
<!-- Wrapper Body -->
<div class="wrapper-body" >
    <div class="page-header align-items-lg-center d-flex flex-column flex-md-row">
      <h3 class="mb-4 mb-md-0">Test Complete Appointments</h3>
      <a href="javascript:void" class="theme-button grey ml-auto mr-3" onclick="filterButton()">Filter</a>
      <button type="button" class="theme-button grey mr-md-3 my-3 my-md-0" onclick="exportCSV()">Export to CSV</button>
      <!-- <a routerLink="../create-appointment" class="theme-button" *ngIf='(userRole=="ADMIN" || userRole=="DIRECTOR")'>Create Appointment</a> -->
    </div>
    <div class="content">
      <form class="custom-form d-none" [formGroup]="filterForm" id="filterShow">
        <div class="row">
          <!-- <div class="col-md-4">
            <input type="text" id="filterSearch" placeholder="Type here to search" onkeyup="appointmentFilterFunction()">
          </div> -->
          <div class="col-md-3">
            <input type="text" formControlName="fromDate" placeholder="From Date" min="2022-01-01" max="3000-01-01"
              onfocus=" this.type='date'">
          </div>
          <div class="col-md-3">
            <input type="text" formControlName="toDate" placeholder="To Date" min="2022-01-01" max="3000-01-01"
              onfocus=" this.type='date'">
          </div>
          <div class="col-md-2">
            <button type="button" form="intakeForm" fo class="theme-button" id="dateRangeFilter"
              (click)="submitFilterForm()">Search</button>
          </div>
        </div>
      </form>
      <div class="card" *ngIf='(userRole=="ADMIN" || userRole=="DIRECTOR") '>
        <div class="table-responsive">
          <!-- <table class="custom-table filterTable" id="appointmentTable"> -->
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="appointmentTable" class="custom-table filterTable row-border hover">
            <thead>
              <tr class="header">
                <th style="display: none;">Id</th> 
                <th class="tablewidth" >Client Name</th>
                <th>Cell Number</th>
                <th>Appt. Date</th>
                <th>Appt. Time</th>
                <th *ngIf='userRole=="ADMIN"'>Location</th>
                <th>Diagnostician</th>
                <th class="export-hide-column">Actions</th>
  
              </tr>
            </thead>
            <tbody>
  
              <!-- Loop -->
              <tr *ngFor="let appointment of appointments; let i = index">
                <td  style="display: none;">{{i}}</td> 
                <td class="tablewidth" >{{appointment.parentDetails.studentFirstName}} {{appointment.parentDetails.studentLastName}}</td>
                <td>{{appointment.parentDetails.cellNumber}} </td>
                <td [attr.data-order]="getSortableDate(appointment.appointmentDetails.schedules[0].appointmentDate)">{{appointment.appointmentDetails.schedules[0].appointmentDate | abbreviatedMonthDate}}</td>
                <td [attr.data-order]="getSortableTime(appointment.appointmentDetails.schedules[0].appointmentTime)">{{appointment.appointmentDetails.schedules[0].appointmentTime}}</td>
                <td *ngIf='userRole=="ADMIN"'>{{appointment.appointmentDetails.location}}</td>
                <td>{{appointment.appointmentDetails.diagnosticianName}}</td>
                <td class="export-hide-column"><a
                    [routerLink]="['/appt-all-details',appointment.appointmentDetails.appointmentId]">View Details</a></td>
  
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card" *ngIf='userRole=="DIAGNOSTIC"  '>
        <div class="table-responsive">
          <!-- <table class="custom-table filterTable" id=""> -->
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="" class="custom-table filterTable row-border hover">
            <thead>
              <tr class="header">
                <th style="display: none;">Id</th> 
                <th class="tablewidth">Client Name</th>
                <th>Cell Number</th>
                <th>Evaluation Test</th>
                <th>Appt. Date</th>
                <th>Appt. Time</th>
                <th>Actions</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
  
              <!-- Loop -->
              <tr *ngFor="let appointment of appointments; let j = index">
                <td  style="display: none;">{{j}}</td> 
                <td class="tablewidth">{{appointment.parentDetails.studentFirstName}} {{appointment.parentDetails.studentLastName}}</td>
                <td>{{appointment.parentDetails.cellNumber}}</td>
                <td class="">{{appointment.appointmentDetails.assesmentType}}</td>
                <td class="" [attr.data-order]="getSortableDate(appointment.appointmentDetails.schedules[0].appointmentDate)">{{appointment.appointmentDetails.schedules[0].appointmentDate | abbreviatedMonthDate}}</td>
                <td class="" [attr.data-order]="getSortableTime(appointment.appointmentDetails.schedules[0].appointmentTime)">{{appointment.appointmentDetails.schedules[0].appointmentTime}}</td>
                <td><a [routerLink]="['/appt-all-details',appointment.appointmentDetails.appointmentId]">View Details</a>
                </td>
  
                <td [ngClass]="{
                    'alert-warning' : (appointment.appointmentDetails.schedules[0].status=='CREATED' || appointment.appointmentDetails.schedules[0].status=='BACKGROUNDFORMSUBMIT'),
                    'alert-info' : appointment.appointmentDetails.schedules[0].status=='REVIEWED',
                    'alert-success' : (appointment.appointmentDetails.schedules[0].status=='ASSESMENT' || appointment.appointmentDetails.schedules[0].status=='COMPLETE'),
                    'alert-danger' : appointment.appointmentDetails.schedules[0].status=='CANCEL'
                  }">
                  <span
                    *ngIf="appointment.appointmentDetails.schedules[0].status=='CREATED' || appointment.appointmentDetails.schedules[0].status=='BACKGROUNDFORMSUBMIT'">Upcoming</span>
                  <span *ngIf="appointment.appointmentDetails.schedules[0].status=='REVIEWED'">Test Ready</span>
                  <span *ngIf="appointment.appointmentDetails.schedules[0].status=='ASSESMENT'">Test Complete</span>
                  <span *ngIf="appointment.appointmentDetails.schedules[0].status=='COMPLETE'">Completed</span>
                  <span *ngIf="appointment.appointmentDetails.schedules[0].status=='CANCEL'">Canceled</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- <div *ngIf="appointments.length<1">
        <div class="row">
          <div class="col-12">
            <div class="card py-5 px-2 text-center">
              <h4 class="text-grey">No Test Complete</h4>
              
            </div>
          </div>
        </div>
      </div> -->

    </div>
  </div>
  
  
  
  
  <!-- Diagno Surveys -->
  <!-- <div class="modal fade" id="modal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="modal"
      aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content text-center light px-5 py-4">
          <h4>test to perform</h4>
          <p>test1</p>
          <h4>survey to perform</h4>
          <p>
            survey 1
          </p>
          <div class="action">
            <a href="javascript:void(0)" class="theme-button grey mx-2" data-dismiss="modal">Close</a>
          </div>
        </div>
      </div>
    </div> -->
  
  <!-- Admin Surveys -->
  
  
  <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-scale-multiple">
    <!-- <p style="color: white">Please Wait... </p> -->
  </ngx-spinner>